import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import ProductSection from "./ProductSection";

const useStyles = makeStyles(theme => ({
  main: {
    minHeight: "calc(100vh - 64px)",
    width: "calc(100% - 300px)"
  }
}));

const Main = ({ sections, scrollTo, onView, onSelectProduct }) => {
  const classes = useStyles();

  return (
    <main className={classes.main}>
      {sections.map((section, index) => (
        <React.Fragment key={`section-${index}`}>
          <ProductSection
            index={index}
            title={section.label}
            products={section.products}
            executeScroll={scrollTo === index}
            onView={onView}
            onSelectProduct={onSelectProduct}
          />
          {index < sections.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </main>
  );
};

export default Main;
